import * as React from "react";
import AccountingDocumentCards from "./AccountingDocumentCards";
import DocumentsPanelHeader from "./DocumentsPanelHeader";
import useExpandableRowIds from "./useExpandableRowIds";

function CreditDocumentsPanel({rows, description, emptyLabel}) {
    const {expandedRowIds, toggleRow, expandAllOf, collapseAll} = useExpandableRowIds();
    const allRowsAreExpanded = rows.length > 0 && expandedRowIds.size === rows.length;

    const toggleAllRows = () => {
        if (allRowsAreExpanded) {
            collapseAll();
        } else {
            expandAllOf(rows.map(row => row.id));
        }
    };

    return (
        <div>
            <DocumentsPanelHeader description={description} allRowsAreExpanded={allRowsAreExpanded} onToggleAll={toggleAllRows}/>
            <AccountingDocumentCards rows={rows} emptyLabel={emptyLabel}
                                      expandedRowIds={expandedRowIds} onToggleRow={toggleRow}/>
        </div>
    );
}

export default CreditDocumentsPanel;
